export default "__VITE_PUBLIC_ASSET__78b2967d__"